/* eslint-disable no-console */
import axios, { AxiosInstance } from 'axios';
import { setupCache } from 'axios-cache-adapter';
import https from 'https';
import { FormError } from 'modules/utils/error/Errors';
// import/no-extraneous-dependencies

const cache = setupCache({
  maxAge: 15 * 60 * 1000,
  clearOnStale: true,
  key: (req) => req.url + JSON.stringify(req.params),
  invalidate: async (config: any, request) => {
    if (request.clearCacheEntry) {
      const storage = config?.store as Storage;
      await storage.removeItem(config.uuid);
    }
  },
});

const axiosApiInstance: AxiosInstance = axios.create({
  withCredentials: true,
  adapter: cache.adapter,
  responseType: 'json',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  xsrfCookieName: 'XSRF-TOKEN',
  httpsAgent: new https.Agent({
    rejectUnauthorized: false,
    requestCert: false,
  }),
  headers: {
    'Content-Type': 'application/json',
  },
});

const logout = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('xsrf');
  window.location.reload();
};

axiosApiInstance.interceptors.request.use((request) => {
  // for non-auth post requests add xsrf to headers (if present)
  if (
    (request.method === 'post' ||
      request.method === 'put' ||
      request.method === 'get' ||
      request.method === 'delete') &&
    request.url?.indexOf('api/login') === -1
  ) {
    const xsrf = localStorage.getItem('xsrf');
    if (xsrf) {
      request.headers = {
        ...request.headers,
        'X-XSRF-TOKEN': xsrf,
      };
    }
  }
  return request;
});

axiosApiInstance.interceptors.response.use(
  (response) => {
    // save xsrf to send it to all requests
    const xsrf = response?.headers
      ? response.headers['x-xsrf-token']
      : undefined;
    xsrf && localStorage.setItem('xsrf', xsrf);
    return response;
  },
  async (error) => {
    console.error('response error', { error });
    // if tokens expire, logout user
    if (
      error.response.status === 401 &&
      error.response.data.path.indexOf('/api/authentication') === -1
    ) {
      localStorage.setItem('systemError', 'loggedOut');
      logout();
    }

    // form validation errors
    if (error.response?.data?.fieldErrors) {
      throw new FormError(
        error.response.data.message || error,
        error.response?.data?.fieldErrors,
      );
    }
    throw new Error(error.response.data.message || error);
  },
);
export const axiosInstance = axiosApiInstance;
